import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Advisory from "./pages/Advisory";
import Appendix from "./pages/Appendix";
import PasswordProtect from "./components/PasswordProtect";

function App() {
  return (
    <div className="App">
      <PasswordProtect>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/advisory" element={<Advisory />} />
            <Route path="/appendix" element={<Appendix />} />
          </Routes>
        </BrowserRouter>
      </PasswordProtect>
    </div>
  );
}

export default App;
